import { render, staticRenderFns } from "./PreCheck.vue?vue&type=template&id=064a06a2&scoped=true"
import script from "./PreCheck.vue?vue&type=script&lang=js"
export * from "./PreCheck.vue?vue&type=script&lang=js"
import style0 from "./PreCheck.vue?vue&type=style&index=0&id=064a06a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a06a2",
  null
  
)

export default component.exports